import { Tab, Button, Dialog, Icon } from '@alifd/next';
import { BefGlobalContext, BefMessageServiceContext } from '@beflam/bef-core';
import { useContext, useEffect, useState } from 'react';
import { AssistantForm } from './AssistantForm';
import './AiAssistant.css';

export class AiAssistantProps {
  onOK: any | undefined;
  onDialogChanged: any | undefined;
  onClose: any | undefined;
}
export function AiAssistant(props: AiAssistantProps) {
  const messageService = useContext(BefMessageServiceContext);
  const sGlobal = useContext(BefGlobalContext) as any;
  const [assistantData, setAssistantData] = useState<any>([]);
  const [isEditAssitant, setIsEditAssitant] = useState<any>(false);
  const [editAssitant, setEditAssitant] = useState<any>({});

  const [visible, setVisible] = useState(false); //修改AI助理弹窗
  const [isFormDirty, setIsFormDirty] = useState(false);

  // 弹窗确认回调
  const handleSubmit = (values: any, errors: any) => {
    if (errors) {
      return;
    }
    let endAssistant = values;
    if (!endAssistant.ChatMode) {
      endAssistant.ChatMode =
        endAssistant.AutoChat !== false ? 'Execute' : 'Input';
    }
    delete endAssistant.AutoChat;
    if (
      endAssistant.ChatMode === 'Combine' &&
      !endAssistant.UserInputPrompt?.trim()
    ) {
      messageService.showMessage(
        messageService.handleErr(
          '合并提示词模式下，用户提示不能为空',
          'AI助理',
        ),
      );
      return;
    }
    endAssistant.Avatar = getValueFromEvent(values.Avatar);
    if (!endAssistant.Avatar && values.Avatar && isEditAssitant)
      endAssistant.Avatar = editAssitant.Avatar;

    if (
      !isEditAssitant &&
      checkExistInArray(assistantData, 'Name', endAssistant.Name)
    ) {
      messageService.showMessage(
        messageService.handleErr('AI助理名称重复', 'AI助理'),
      );
    } else {
      addAsisstant(endAssistant);
    }
  };

  function checkExistInArray(
    jsonArray: any[],
    fieldName: string | number,
    fieldValue: any,
  ) {
    return jsonArray.some((item) => {
      return item.hasOwnProperty(fieldName) && item[fieldName] === fieldValue;
    });
  }

  const refresh = async () => {
    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/assistants`;

      const response = await fetch(postUrl, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${sGlobal.session.id}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok === false) {
        return;
      }

      const data = await response.json();
      if (data && data.code === 0) {
        let _data = [{ Name: '默认', Avatar: '' }] as any;
        if (data.data.length > 0) {
          data.data.forEach((data: any) => {
            _data.push(data);
          });
        }
        setAssistantData(_data);
      } else if ((data && data.code, data.message)) {
        messageService.showMessage(
          messageService.handleErr(data.message, 'AI助理'),
        );
      }
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI助理'));
    }
  };

  const addAsisstant = async (assistant: any) => {
    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/saveassistant`;

      const response = await fetch(postUrl, {
        method: 'post',
        headers: {
          Authorization: `Bearer ${sGlobal.session.id}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(assistant),
      });

      if (response.ok === false) {
        messageService.showMessage(
          messageService.handleErr('添加AI助理失败', 'AI助理'),
        );
        return;
      }

      const data = await response.json();
      if (data && data.code === 0) {
        refresh();
        closeDialog();
      } else if ((data && data.code, data.message)) {
        messageService.showMessage(
          messageService.handleErr(data.message, 'AI助理'),
        );
      }
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI助理'));
    }
  };

  const checkDelectAssistant = async (assistant: any) => {
    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/deleteassistant`;

      const response = await fetch(postUrl, {
        method: 'post',
        headers: {
          Authorization: `Bearer ${sGlobal.session.id}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(assistant),
      });

      if (response.ok === false) {
        messageService.showMessage(
          messageService.handleErr('删除AI助理失败', 'AI助理'),
        );
        return;
      }

      const data = await response.json();
      if (data && data.code === 0) {
        refresh();
        props.onDialogChanged?.(false);
      } else if ((data && data.code, data.message)) {
        messageService.showMessage(
          messageService.handleErr(data.message, 'AI助理'),
        );
      }
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI助理'));
    }
  };

  // 处理头像上传结果，提取接口返回的地址
  const getValueFromEvent = (files: { response: { fileId: any } }[]) => {
    if (files && files[0] && files[0].response) {
      return files[0].response.fileId;
    }
    return '';
  };

  type UserItemType = {
    Name: string;
    Avatar: string;
  };

  const onTabChange = (key: any) => {};

  const getMenuItemTem = (item: UserItemType) => {
    return (
      <>
        <div className="menu-card-div"  style={{width:'180px',height:'144px'}}>
          <div
            className="menu-card"
            onClick={() => onMenuItemClick(item)}
            style={{ display: 'flex', alignItems: 'center',flexDirection:'column',gap:'8px',position:'relative' }}
          >
            {item.Avatar ? (
              <img
                style={{
                  width: 52,
                  height: 52,
                  objectFit: 'contain',
                  margin: 'auto',
                  borderRadius: '50%',
                }}
                alt={item.Name}
                src={
                  item.Avatar
                    ? `${sGlobal.config.host}/${item.Avatar}`
                    : './assets/img/avatar1.png'
                }
              ></img>
            ) : (
              <i className="bef-ai-i" style={{fontSize:'52px',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',width:'52px',height:'52px',backgroundColor:'#e8f4ff' ,color:'#2b8cff'}}>
                <svg
                  viewBox="0 0 1024 1024"
                  width="22px"
                  height="22px"
                  fill="currentColor"
                >
                  <path d="M269.69088 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464s68.46464-30.64832 68.46464-68.46464c0-37.80608-30.65856-68.46464-68.46464-68.46464s-68.46464 30.65856-68.46464 68.46464zM899.54304 1.21856H123.63776c-20.19328 0-36.51584 16.32256-36.51584 36.51584v753.09056c0 20.19328 16.32256 36.5056 36.51584 36.5056h775.90528c20.19328 0 36.5056-16.31232 36.5056-36.5056V37.7344c0.01024-20.19328-16.30208-36.51584-36.5056-36.51584zM863.0272 754.30912H160.14336V74.25024H863.0272v680.05888zM616.56064 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464 37.81632 0 68.46464-30.64832 68.46464-68.46464 0-37.80608-30.64832-68.46464-68.46464-68.46464-37.80608 0-68.46464 30.65856-68.46464 68.46464z m285.4912 634.4192H121.12896c-18.82112 0-34.00704 16.32256-34.00704 36.51584v41.07264c0 5.02784 3.76832 9.13408 8.448 9.13408h831.92832c4.67968 0 8.448-4.10624 8.448-9.13408v-41.07264c0.11264-20.20352-15.06304-36.51584-33.8944-36.51584zM685.02528 507.84256H338.15552c-5.0176 0-9.12384 4.10624-9.12384 9.13408v68.46464c0 5.0176 4.10624 9.12384 9.12384 9.12384h346.88c5.0176 0 9.13408-4.10624 9.13408-9.12384v-68.46464c-0.01024-5.02784-4.11648-9.13408-9.14432-9.13408z m0 0" />
                </svg>
              </i>
            )}

            <div className="menu-card-right" style={{width:'100%'}}>
              <div className="menu-card-assistant-div" >
                <p className="menu-card-assistant-text" title={item.Name}>
                  {item.Name}
                </p>
              </div>
            </div>
            <div className="menu-card-edit">
              {item.Name !== '默认' && (
                <button
                  className="assistant-close-button"
                  onClick={(e) => onMenuEdit(e, item)}
                >
                  <Icon
                    type={'edit'}
                    size="xs"
                    style={{ fontWeight: 'bold' }}
                  />
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  //点击菜单
  const onMenuItemClick = (assistant: UserItemType) => {
    if (assistant.Name === '默认') {
      if (props.onOK) {
        props.onOK({ ...assistant, Name: null }); //这里Name要设置为空
      }
    } else {
      getAIAssistant(assistant);
    }
  };

  //修改助理
  const onMenuEdit = (e: any, assistant: UserItemType) => {
    getAIAssistant(assistant, true);
    const evt = e || (window.event as any);
    if (evt.stopPropagation) {
      evt.stopPropagation();
      evt.nativeEvent.stopImmediatePropagation();
    } else {
      evt.cancelBubble = true;
    }
  };

  const closeDialog = () => {
    setVisible(false);
    setIsEditAssitant(false);
    setEditAssitant({});
    setIsFormDirty(false);
    props.onDialogChanged?.(false);
  };

  const dialogClose = (e?: any) => {
    if (isFormDirty) {
      Dialog.confirm({
        title: '未保存的更改',
        content: '您有未保存的更改，确定要放弃并关闭吗？',
        closeMode: ['close', 'esc', 'mask'],
        onOk: () => {
          closeDialog();
          return new Promise<void>((resolve) => setTimeout(resolve, 300));
        },
      });
      return;
    }
    closeDialog();
  };

  // 点击历史记录行：关闭编辑对话框，打开聊天界面并显示对应历史会话
  const onHistorySelect = (item: { Id: string; Title: string; Star: any }) => {
    setVisible(false);
    setIsEditAssitant(false);
    setEditAssitant({});
    props.onDialogChanged?.(false);
    props.onClose?.();
    sGlobal.aiVisibleEvent.emit({
      visible: true,
      type: '',
      params: {
        colleague: editAssitant,
        initConversation: { id: item.Id, star: item.Star, key: Date.now() },
      },
    });
  };

  //获取自定义助理配置详情
  const getAIAssistant = async (assistant: any, isEdit: boolean = false) => {
    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/assistants?id=${assistant.Name}`;

      const response = await fetch(postUrl, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${sGlobal.session.id}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok === false) {
        return;
      }

      const data = await response.json();
      if (data && data.code === 0) {
        if (isEdit) {
          setEditAssitant(data.data);
          setIsEditAssitant(true);
          setVisible(true);
          props.onDialogChanged?.(true);
        } else if (props.onOK) {
          props.onOK(data.data);
        }
      } else if ((data && data.code, data.message)) {
        messageService.showMessage(
          messageService.handleErr(data.message, 'AI助理'),
        );
      }
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI助理'));
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <>
      <div className=" bef-custom-fun bef-fun">
        <div className="bef-fun-main">
          <div className="tab-div">
            <Tab
              onChange={onTabChange}
              unmountInactiveTabs
              defaultActiveKey="0"
              excessMode="slide"
              extra={
                <Button
                  type="primary"
                  size="medium"
                  style={{ marginRight: 10, marginTop: 10 }}
                  onClick={() => {
                    setVisible(true);
                    props.onDialogChanged?.(true);
                  }}
                >
                  添加自定义助理
                </Button>
              }
            >
              <Tab.Item title={'AI助理'} key={0}>
                <div className="menu-con-scroll">
                  <div className="menu-con tab-item">
                    <>
                      {assistantData?.map((item2: UserItemType) =>
                        getMenuItemTem(item2),
                      )}
                    </>
                  </div>
                </div>
              </Tab.Item>
            </Tab>
            {visible ? (
              <Dialog
                title={editAssitant.Name ? '修改助理' : '添加助理'}
                visible={visible}
                onOk={() => {}}
                onCancel={dialogClose}
                onClose={dialogClose}
                footer={false}
                closeMode={['close', 'esc', 'mask']}
                onClick={(e) => e.stopPropagation()}
                wrapperStyle={{ pointerEvents: 'auto' }}
              >
                <AssistantForm
                  editAssitant={editAssitant}
                  isEditAssitant={isEditAssitant}
                  handleSubmit={handleSubmit}
                  sGlobal={sGlobal}
                  onCancel={dialogClose}
                  onDirtyChange={setIsFormDirty}
                  onDelete={
                    isEditAssitant
                      ? () => {
                          checkDelectAssistant(editAssitant);
                          closeDialog();
                        }
                      : undefined
                  }
                  onHistorySelect={onHistorySelect}
                />
              </Dialog>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
